
/* before load javascript */
var body = document.querySelector("body").classList;
body.add("script", "scroll-on-top");

/* init Feather icons */
var feather = false;